/* eslint-disable no-alert, no-unreachable */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import authSelector from '../../selectors/authSelector'
import { FETCH_CONTACTS_INFO } from '../../actions/actions'

const phoneIcon = (
  <i className="fa fa-phone" style={{ fontSize: 18 }} aria-hidden="true" />
)

const telegramIcon = (
  <i className="fa fa-telegram" style={{ fontSize: 18 }} aria-hidden="true" />
)

const emailIcon = (
  <i className="fa fa-envelope" style={{ fontSize: 18 }} aria-hidden="true" />
)

const SupportInfoRow = ({ medium, icon, title }) => (
  <div className="support-row">
    <span className="support-row__icon">{icon}</span>

    <strong className="support-row__title">{title}</strong>
    <span>{medium && medium.value}</span>

    <span className="support-row__description">
      {medium && medium.description && medium.description}
    </span>
  </div>
)

const SupportInfo = ({ contacts: [phone, email, telegram] }) => {
  return (
    <section className="support-info-list">
      <SupportInfoRow medium={phone} title="شماره تلفن پشتیبانی: " icon={phoneIcon} />
      <SupportInfoRow medium={telegram} title="تلگرام: " icon={telegramIcon} />
      <SupportInfoRow medium={email} title="ایمیل: " icon={emailIcon} />
    </section>
  )
}

const ContactInfo = ({ contacts }) => (
  <section id="support-info-wrapper">
    <h3>اطلاعات تماس پشتیبانی</h3>

    <div style={{ marginLeft: 'auto' }}>
      <SupportInfo contacts={contacts} />
    </div>
  </section>
)

const InboxNavItem = ({ title, labelClass, countValue, linkAdd }) => (
  <Link to={linkAdd} className="messages-navigation__link">
    <span className="messages-navigation__link__icon">
      <i className={labelClass} aria-hidden="true" />
      <span>{countValue}</span>
    </span>
    <span className="messages-navigation__link__icon">{title}</span>
  </Link>
)

const MessagesNavigation = ({ userType }) => (
  <section className="messages-navigation">
    {/* <InboxNavItem
      linkAdd="/dashboard/messages"
      title="دریافتی"
      labelClass="fa fa-envelope"
    />

    <InboxNavItem
      linkAdd="/dashboard/messages/sent"
      title="ارسال شده"
      labelClass="fa fa-paper-plane"
    /> */}

    {userType === 'MANAGER' ? (
      <InboxNavItem
        linkAdd="/dashboard/messages/broadcasts"
        title="پیام های دسته جمعی"
        labelClass="fa fa-bell"
      />
    ) : (
      <InboxNavItem
        linkAdd="/dashboard/messages/broadcasts-inbox"
        title="اعلان ها"
        labelClass="fa fa-bell"
      />
    )}

    {userType === 'MANAGER' && (
      <InboxNavItem
        linkAdd="/dashboard/messages/emails"
        title="ایمیل ها"
        labelClass="fa fa-at"
      />
    )}

    {userType === 'MANAGER' && (
      <InboxNavItem
        linkAdd="/dashboard/messages/sms"
        title="اس ام اس ها"
        labelClass="fa fa-mobile"
      />
    )}
  </section>
)

class MessagesContainer extends Component {
  componentWillMount() {
    this.props.dispatch({ type: FETCH_CONTACTS_INFO })
  }

  static contextTypes = { router: PropTypes.object }

  render() {
    const {
      userType,
      contacts,
      location: { pathname },
    } = this.props

    const isInComposeView = pathname !== '/dashboard/messages/compose'

    const navigationProps = {
      userType,
      isInComposeView,
      contacts,
    }

    return (
      <main className="messages-container">
        <section className="messages">
          {/* <MessagesNavigation userType={userType} /> */}
          {this.props.children}
        </section>

        <ContactInfo {...navigationProps} />
      </main>
    )
  }
}

function mapStateToProps(state) {
  return {
    contacts: state.contacts,
    ...authSelector(state),
  }
}

export default connect(mapStateToProps)(MessagesContainer)



// WEBPACK FOOTER //
// ./src/components/dashboard/MessagesContainer.js